import FoodOperatorService from 'src/modules/foodOperator/foodOperatorService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { i18n } from 'src/i18n';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'FOODOPERATOR_FORM';

const foodOperatorFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: foodOperatorFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await FoodOperatorService.find(id);
      }

      dispatch({
        type: foodOperatorFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: foodOperatorFormActions.INIT_ERROR,
      });

      navigateTo('/library/food-operator');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: foodOperatorFormActions.CREATE_STARTED,
      });

      await FoodOperatorService.create(values);

      dispatch({
        type: foodOperatorFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.foodOperator.create.success'));

      navigateTo('/library/food-operator');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: foodOperatorFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: foodOperatorFormActions.UPDATE_STARTED,
      });

      await FoodOperatorService.update(id, values);

      dispatch({
        type: foodOperatorFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.foodOperator.update.success'));

      navigateTo('/library/food-operator');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: foodOperatorFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default foodOperatorFormActions;
